<template>
  <v-dialog v-model="dialog" width="600" :persistent="true">
    <template v-slot:activator="{ on }">
      <icon-button
          icon="edit"
          color="green"
          cls="mr-0 ml-0"
          @click="open"
          :tooltip="{top: true, bottom: false, attach: false}"
          :iconOptions="{small: true}"
          :permission="hasPermission('surveys_create')"
      >
        {{ 'app.surveys.edit_question' | trans }}
      </icon-button>
    </template>
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>
          {{ 'app.surveys.edit_question' | trans }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap align-center>
            <v-flex xs12>
              <v-form ref="editQuestionForm" v-model="valid" lazy-validation v-on:submit.prevent="close()">
                <v-text-field
                    :label="'app.surveys.question' | trans"
                    clearable
                    v-model="questionModel"
                    :rules="rules.question"
                    full
                ></v-text-field>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
        <v-btn color="primary" :disabled="!valid"
               @click="close()">
          {{ 'app.save' | trans }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {trans} from "../../../app";
import {mapGetters} from "vuex";

export default {
  data: function () {
    return {
      dialog: false,
      valid: false,
      questionModel: null
    }
  },
  props: {
    question: String,
  },
  methods: {
    open: function () {
      this.questionModel = this.question;
      this.dialog = true;
    },
    close: function () {
      if (this.valid) {
        this.dialog = false;
        this.$emit('closed', {
          question: this.questionModel
        });
      }
    }
  },
  computed: {
    ...mapGetters(['hasPermission']),
    rules: function () {
      return {
        question: [
          v => !!v || trans('app.surveys.validation.question.required'),
          v => v && v.length >= 1 || trans('app.surveys.validation.question.min', {min: '1'}),
          v => v && v.length <= 255 || trans('app.surveys.validation.question.max', {max: '255'}),
        ],
      };
    },
  }
}
</script>